module.exports = {
  TYPE_IMAGE_IS_INVALID: "نوع عکس شما نامعتبر است.",
};
